import React from "react";
import Global_Opportunities from "../Global_Opportunities/Global_Opportunities";
import StatsSection from "../StatsSection/StatsSection";
import ServicesSection from "../../components/New_Folder/Services_Section/Services_Section";
import WhyChooseUs from "./Why_Choose_Us/Why_Choose_Us";
import ReadyToStart from "./Ready_To_Start/Ready_To_Start";
import About from "./About_Section/About_Section";
import GlobalCareerCTA from "./GlobalCareerCTA/GlobalCareerCTA";
import Certificate from "../Home/Certificate/Certificate";

function Home() {
  return (
    <div className="new-home-page">
      <Global_Opportunities />
      <StatsSection />
      <ServicesSection />
      <About />
      <Certificate />
      <WhyChooseUs />
      {/* <ReadyToStart /> */}
      <GlobalCareerCTA />
    </div>
  );
}

export default Home;
